import { ReassignActionData } from "PFApp/booking/parts/overview/booking_module_calendar/context/reassign_action_context_provider";
import { createContext, useContext } from "react";

export type ReassignActionState = {
  isModalOpened: boolean;
  data: ReassignActionData | null;
};

export type ReassignActionApi = {
  openModal: (data: ReassignActionData) => void;
  closeModal: () => void;
};

export const INITIAL_STATE: ReassignActionState = {
  isModalOpened: false,
  data: null
};
const INITIAL_API: ReassignActionApi = {
  openModal: () => {},
  closeModal: () => {}
};

export const ReassignActionApiContext = createContext<ReassignActionApi>(INITIAL_API);
export const ReassignActionStateContext = createContext<ReassignActionState>(INITIAL_STATE);

export const useReassignActionApi = () => useContext(ReassignActionApiContext);
export const useReassignActionState = () => useContext(ReassignActionStateContext);
